// JavaScript для index
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для index
});
